import { Injectable, computed } from '@angular/core';

import { DASHBOARD_METRIC_CATALOG } from '../data/dashboard-catalog.data';
import type { DashboardMetricDefinition } from '../types';

@Injectable({ providedIn: 'root' })
export class DashboardCatalogService {
  readonly metricIndex = computed<Readonly<Record<string, DashboardMetricDefinition>>>(() => {
    const index: Record<string, DashboardMetricDefinition> = {};
    for (const m of DASHBOARD_METRIC_CATALOG) index[m.key] = m;
    return index;
  });
}
